import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  CreateModelAssetParams,
  Error
} from '@eggplant/types'

interface Props {
  modelId: string
  params?: CreateModelAssetParams
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => void
}

const CreateAiModelAssetRequest = ({
  modelId,
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${modelId}/assets`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateAiModelAssetRequest
